export default __webpack_public_path__ + "static/modelo-celular-0dc88bc5b35885d746a8b31839ac2197.png";